import type { PractitionerTitle, UserData } from '@shared/types';

type PractitionerTitleSource = Pick<
  UserData,
  'isAttorney' | 'practitionerTitle'
>;

export const practitionerTitles: PractitionerTitle[] = ['attorney', 'llp'];

export const getPractitionerTitle = (
  user: PractitionerTitleSource | undefined,
): PractitionerTitle | undefined => {
  if (!user?.isAttorney) {
    return undefined;
  }

  return user.practitionerTitle ?? 'attorney';
};

export const getPractitionerTitleLabel = (
  user: PractitionerTitleSource | undefined,
): string | undefined => {
  const practitionerTitle = getPractitionerTitle(user);

  if (practitionerTitle === 'llp') {
    return 'LLP';
  }

  if (practitionerTitle === 'attorney') {
    return 'Attorney';
  }

  return undefined;
};

export const getPractitionerTitleReference = (
  user: PractitionerTitleSource | undefined,
): string | undefined => {
  const practitionerTitle = getPractitionerTitle(user);

  if (practitionerTitle === 'llp') {
    return 'LLP';
  }

  if (practitionerTitle === 'attorney') {
    return 'attorney';
  }

  return undefined;
};
